export default __webpack_public_path__ + "static/media/GMM-Mani-Mobile.a49519f7.webp";